import React, { useEffect, useState } from "react";
import "./Agenda.css";

const Image = ({ src, right }) => {
    const [imageError, setImageError] = useState(false);

    const handleError = () => {
        setImageError(true);
    };

    useEffect(() => {
        setImageError(false);
    }, [src]);

    // Dynamic classes
    const imageClass = `card-img ${right ? "margin-right" : ""}`;

    return (
        <>
            {imageError || !src ? (
                <svg className={imageClass} viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M0 0m42.666667 0l938.666666 0q42.666667 0 42.666667 42.666667l0 938.666666q0 42.666667-42.666667 42.666667l-938.666666 0q-42.666667 0-42.666667-42.666667l0-938.666666q0-42.666667 42.666667-42.666667Z"
                        fill="#F7F7F7"
                    />
                    <path
                        d="M795.136 320.256a29.226667 29.226667 0 0 0-20.437333-9.386667l-222.378667-8.746666-16.853333 37.12 23.168 69.888-41.856 79.488 17.066666 64 42.24 54.954666 61.184-56.576a14.72 14.72 0 0 1 20.736 0.853334l78.72 85.162666a14.848 14.848 0 0 1 2.56 16.128 14.762667 14.762667 0 0 1-13.909333 8.533334l-215.68-8.448-10.752 30.890666 11.648 27.904 247.978667 9.6a29.354667 29.354667 0 0 0 30.464-28.245333L802.858667 341.333333a29.013333 29.013333 0 0 0-7.722667-21.077333z m-159.36 161.408a44.074667 44.074667 0 1 1 3.456-88.021333 44.074667 44.074667 0 0 1-3.456 88.021333z m-159.872 202.965333l7.466667-32.426666-175.146667 12.074666a14.677333 14.677333 0 0 1-12.117333-24.32l129.792-149.034666a14.677333 14.677333 0 0 1 21.632-0.512l43.434666 45.312-18.688-48.298667 32.938667-83.370667-30.378667-66.730666 12.672-38.656-238.848 16.469333a29.312 29.312 0 0 0-27.221333 31.36l24.234667 351.573333a29.013333 29.013333 0 0 0 9.941333 20.053334c5.888 5.077333 13.568 7.68 21.333333 7.168l213.248-14.72-14.293333-25.941334z"
                        fill="#CCCDCF"
                    />
                </svg>
            ) : (
                <img
                    className={imageClass}
                    src={src}
                    alt="Venue"
                    onError={handleError}
                />
            )}
        </>
    );
};

export default Image;
